<template>
  <MRow :gutter="0">
    <MCol>
      <MRow>
        <MCol>
          <FlotoFormItem
            id="name-input"
            v-model="formData.name"
            auto-focus
            :label="$tc('name')"
            :placeholder="$t('name')"
            rules="required|min:1|max:100"
          />
        </MCol>
      </MRow>
      <MRow>
        <MCol>
          <FlotoFormItem
            id="description-input"
            v-model="formData.description"
            :label="$t('description')"
            rules="required|description"
            type="textarea"
            :rows="5"
            :placeholder="$t('description')"
          />
        </MCol>
      </MRow>
    </MCol>
  </MRow>
</template>

<script>
export default {
  name: 'NoteForm',
  props: {
    formData: { type: Object, required: true },
  },
}
</script>
